import { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarItem, SidebarSection } from '../Sidebar';
import { NavSection } from './types';

interface NavigationMenuProps {
    sections: NavSection[];
    /** Tiroir mobile : ferme le tiroir au clic. */
    onItemClick?: () => void;
}

/**
 * Rendu du menu latéral, partagé par la barre bureau et le tiroir mobile.
 *
 * Les deux affichaient chacun leur copie ligne à ligne du même menu : toute
 * évolution devait être faite deux fois, et divergeait tôt ou tard.
 */
export default function NavigationMenu({ sections, onItemClick }: NavigationMenuProps) {
    const { pathname, search } = useLocation();

    return (
        <>
            {sections.filter((section) => section.items.length > 0).map((section) => (
                <Fragment key={section.key}>
                    {section.label && <SidebarSection label={section.label} />}
                    {section.items.map((item) => (
                        <SidebarItem
                            key={item.key}
                            link={item.link}
                            icon={item.icon}
                            text={item.text}
                            active={item.isActive ? item.isActive(pathname, search) : pathname.startsWith(item.link)}
                            badgeCount={item.badgeCount}
                            onClick={onItemClick}
                        />
                    ))}
                </Fragment>
            ))}
        </>
    );
}
